import { Injectable } from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { UserSessionService } from './UserSession/user-session.service';
import * as moment from 'moment';
import { Observable } from 'rxjs';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

/**
 * Servicio que expone los métodos para exportar en formato PDF
 */
@Injectable({
  providedIn: 'root'
})
export class PdfExporterService {


  constructor(private userSessionService: UserSessionService) { }

  /**
   * Exporta los registros de tipo Plaga en formato PDF
   * @param registros
   * @returns
   */
  exportDiseaseReport(registros: any[]): Observable<any>{
console.log("Generar un pdf con untotal de " +registros.length)
    return new Observable((observer) => {
      moment.locale('es');

      let report = JSON.parse(JSON.stringify(registros));




       report.map((registro) => {
         registro.username = registro.diseaseUser.name +" " +registro.diseaseUser.surname

         if(null != registro.localizacion && registro.localizacion.type === "Point"){
           registro.localizacion = "https://www.google.com/maps/@"
             + registro.localizacion.coordinates[1]
             + "," + registro.localizacion.coordinates[0] +",15z";
         }else{
           registro.localizacion = '-';
         }

         if (null != registro.imagen && registro.imagen.startsWith('content')){
            registro.imagen = null;
         }
         if(null != registro.imagen && registro.imagen != '' && !registro.imagen.startsWith('content')){
           registro.imagen = 'https://api.smartrural.es:8084/v1/image/report' + registro.imagen+'?th=true';;
         }
         return registro;
       });






       this.getBase64Logo().subscribe((base64url) => {
        var imagenes = {};
        imagenes['logo'] = base64url;

        var cabecera = [
          {image:'logo', alignment:'center',width:150,lineheight:1.5},
          {text:' ',lineHeight:1.5},
          {
            text : this.userSessionService.user.company.name,
            fontSize:16,bold:true,alignment:'center',lineHeight:1.5
          },
          {
            text: moment().format('DD/MM/YYYY, HH:mm:ss'),
            fontSize:12,bold:true,alignment:'center',lineHeight:1.5
          },
          {
           text: 'Plagas/Enfermedades',
           fontSize:14,bold:true,alignment:'center',lineHeight:2
         }
        ];

       var tablaInformes = {
         layout: 'lightHorizontalLines', // optional
         table: {
           // headers are automatically repeated if the table spans over multiple pages
           // you can declare how many rows should be treated as headers
           headerRows: 1,
           widths: [ 80, 80, 80,60,60,120,100, 'auto' ],
           fontSize: 10,
           body: [
             [ { text: 'Usuario', fontSize: 10,bold:true },
             { text: 'Plagas/Enfermedades', fontSize: 10,bold:true },
             { text: 'Fecha/Hora', fontSize: 10,bold:true },
             { text: 'Temperatura', fontSize: 10,bold:true },
             { text: 'Humedad', fontSize: 10,bold:true },
             { text: 'Ubicacion', fontSize: 10,bold:true },
             { text: 'Comentarios', fontSize: 10,bold:true },
             { text: 'Imagen', fontSize: 10,bold:true }],

           ]
         }
       };

       report.forEach((registro) => {
         var fila = [
             { text: registro.username},
             { text: registro.diseaseName},
             { text: moment(registro.datetime).format('DD/MM/YYYY, HH:mm')},
             { text: registro.temperature},
             { text: registro.humidity},
             { text: registro.localizacion},
             { text: registro.comentarios},

         ];

         if(registro.imagen != "" && registro.imagen != null){
           imagenes[registro.id+"_img"] = registro.imagen;
           (fila as Array<any>).push( { image: registro.id+"_img",width:50});
         }else{
           (fila as Array<any>).push( {text:''});
         }
         (tablaInformes.table.body as Array<any>).push(fila);
       })

       console.log(tablaInformes.table)

       var docDefinition = {
         defaultStyle: {
           fontSize: 10,
         },
         pageOrientation: 'landscape',
         images:imagenes,
         content: (cabecera as Array<any>).concat([tablaInformes])
       };

       pdfMake.createPdf(docDefinition).download('InformePlagas.pdf',() => {
         observer.next(true);
       });
       })
    })



  }

  /**
   * Exporta los registros de tipo Mantenimiento en formato PDF
   * @param registros
   * @returns
   */
  exportMaintenanceReport(registros: any[]): Observable<any>{

    return new Observable((observer) => {
      moment.locale('es');

      let report = JSON.parse(JSON.stringify(registros));




       report.map((registro) => {
         registro.username = registro.maintenanceUser.name +" " +registro.maintenanceUser.surname

         if(null != registro.localizacion && registro.localizacion.type === "Point"){
           registro.localizacion = "https://www.google.com/maps/@"
             + registro.localizacion.coordinates[1]
             + "," + registro.localizacion.coordinates[0] +",15z";
         }else{
           registro.localizacion = '-';
         }
         if (null != registro.imagen && registro.imagen.startsWith('content')){
          registro.imagen = null;
       }
         if(null != registro.imagen && registro.imagen != '' && !registro.imagen.startsWith('content')){
           registro.imagen = 'https://api.smartrural.es:8084/v1/image/report' + registro.imagen+'?th=true';;
         }
         return registro;
       });






       this.getBase64Logo().subscribe((base64url) => {
        var imagenes = {};
        imagenes['logo'] = base64url;

        var cabecera = [
          {image:'logo', alignment:'center',width:150,lineheight:1.5},
          {text:' ',lineHeight:1.5},
          {
            text : this.userSessionService.user.company.name,
            fontSize:16,bold:true,alignment:'center',lineHeight:1.5
          },
          {
            text: moment().format('DD/MM/YYYY, HH:mm:ss'),
            fontSize:12,bold:true,alignment:'center',lineHeight:1.5
          },
          {
           text: 'Mantenimientos',
           fontSize:14,bold:true,alignment:'center',lineHeight:2
         }
        ];

       var tablaInformes = {
         layout: 'lightHorizontalLines', // optional
         table: {
           // headers are automatically repeated if the table spans over multiple pages
           // you can declare how many rows should be treated as headers
           headerRows: 1,
           widths: [ 80, 80, 80,'auto',100, 'auto' ],
           fontSize: 10,
           body: [
             [ { text: 'Usuario', fontSize: 10,bold:true },
             { text: 'Mantenimiento', fontSize: 10,bold:true },
             { text: 'Fecha/Hora', fontSize: 10,bold:true },
             { text: 'Ubicacion', fontSize: 10,bold:true },
             { text: 'Comentarios', fontSize: 10,bold:true },
             { text: 'Imagen', fontSize: 10,bold:true }],

           ]
         }
       };

       report.forEach((registro) => {
         var fila = [
             { text: registro.username},
             { text: registro.maintenanceName},
             { text: moment(registro.datetime).format('DD/MM/YYYY, HH:mm')},
             { text: registro.localizacion},
             { text: registro.comentarios},

         ];

         if(registro.imagen != "" && registro.imagen != null){
           imagenes[registro.id+"_img"] = registro.imagen;
           (fila as Array<any>).push( { image: registro.id+"_img",width:50});
         }else{
           (fila as Array<any>).push( {text:''});
         }
         (tablaInformes.table.body as Array<any>).push(fila);
       })

       console.log(tablaInformes.table)

       var docDefinition = {
         defaultStyle: {
           fontSize: 10,
         },
         pageOrientation: 'landscape',
         images:imagenes,
         content: (cabecera as Array<any>).concat([tablaInformes])
       };

       try{
        var targetpdf = pdfMake.createPdf(docDefinition)

        targetpdf.download('InformeMantenimientos.pdf',() => {
          observer.next(true);
        },(error) => {
          observer.error(error)
        });
       }catch(error){
        observer.error(error)
       }

       })
    })



  }

  /**
   * @ignore
   * @param localizacion
   * @returns
   */
  geojson2PostGis(localizacion: any): any {
    let postgisStr = "POLYGON ((";
    localizacion.coordinates[0].forEach((element,index) => {
      if (index == 0){
          postgisStr = postgisStr + element[0] + " " + element[1];
      }else{
        postgisStr = postgisStr + "," + element[0] + " " + element[1];
      }
    });

    postgisStr = postgisStr + "))";

    return postgisStr;
  }


  /**
   * @ignore
   * @returns
   */
  getBase64Logo(): Observable<any> {
    return new Observable((resolver) => {
      var xhr = new XMLHttpRequest;
      xhr.responseType = 'blob';

      xhr.onload = function() {
        var recoveredBlob = xhr.response;

        var reader = new FileReader;

        reader.onload = function() {
          var blobAsDataUrl = reader.result;
          resolver.next(blobAsDataUrl);
        };

        reader.readAsDataURL(recoveredBlob);
      };

      xhr.open('GET', document.getElementById('companylogo').getAttribute('src'));
      xhr.send();
    })
  }
}
